import React from 'react';
import {css} from 'emotion';
import Avatar from '../../../common/avatar';

const ItemAvatar = (props) =>{



  return(
    <div onClick={(e)=>{props.onChoose(props.item)}} className={css`min-height:100px;cursor:pointer;width:25%;box-sizing:border-box;display:flex;align-items:center;justify-content:center`}>
      <div className={css`border-radius:50%;border:${props.isSelect == props.item ? '2px solid #0085C6': 'none'};display:flex;align-items:center;justify-content:center;box-sizing:border-box;padding:5px;`}><Avatar id_avatar={props.item} style={{width:50,height:50}}/></div>
    </div>
  )
}

export default ItemAvatar
